class abortControllerManager {
  controller: { [key: string]: AbortController };
  constructor() {
    this.controller = {};
  }
  //Recommend to call getSignal with either the action name
  getSignal(key: string) {
    if (this.controller[key]) this.controller[key].abort();

    this.controller[key] = new AbortController();
    return this.controller[key].signal;
  }
}

export default new abortControllerManager();
